import { handleActions } from 'redux-actions';
import { FormState } from '../constants/model';
import Immutable from 'immutable';

const formReducer = handleActions({
    SET_FORMVALUE : (state, { payload })=>{
        return state.set( payload.field, payload.value)
    },

}, FormState)

export default formReducer
